import { css } from 'linaria';

export namespace Styles {
  export const removeButton = css`
    position: absolute;
    top: -12px;
    right: -12px;
    width: var(--space-300);
    height: var(--space-300);
    background-color: var(--background-primary);
    border-radius: 50%;
  `;

  export const removeButtonIcon = css`
    width: var(--space-250) !important;
    height: var(--space-250) !important;
    transition: 0.3s;
    fill: var(--control-secondary) !important;
    &:hover {
      fill: var(--control-hover-secondary) !important;
    }
  `;

  export const inProcessSpinView = css`
    position: absolute;
    top: -2px;
    left: -2px;
    color: var(--success-primary);
    --loader-size: var(--space-350) !important;
  `;
}
